import type { FaireProductEntity } from "../../entity_types/product";

export const p_52vprc2nhj: FaireProductEntity = {
  token: "p_52vprc2nhj",
  type: "product",
  name: "holly sticker",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/9b96e87ca38b909cbb7b2b33f975bb55bc320cabd513c8597e2ec4e8d2f70504.jpeg",
  galleryImageUrls: [],
  priceDollars: 2,
  description:
    'Add this sticker to your water bottle, laptop, journal, envelopes, and more.\n\n• vinyl sticker\n• 3" x 3"\n• Original watercolor artwork by Emily Lex',
  tags: [],
  msrpDollars: 4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:15:11.063Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
